import React from 'react'
import {connect} from 'react-redux'

import {Flex, Tabs, CheckboxInput, Arrow} from '/app/src/component'
import _ from 'lodash'

import Preview from '/app/src/component/Conversation/Preview'
import ExchangeNotification from './ExchangeNotification'
import style from './index.css'

import ExchangeSelector from '/app/src/model/Exchange/selector';
import ConversationSelector from '/app/src/model/Conversation/selector';
import CustomizationModel from '/app/src/model/Customization/model';
import CustomizaionSelector from '/app/src/model/Customization/selector';
import {ExchangeModel} from '/app/src/model'
import ConversationModel from '/app/src/model/Conversation/model';
import CompanySelector from '/app/src/model/Company/selector';

import WithPaymentPermission from '/app/src/hoc/withPaymentPermission'

import SVG from 'react-inlinesvg';

class LeftPanel extends React.Component {
    constructor(props) {
        super(props);
        this._renderSection = this._renderSection.bind(this);
        this._renderUnassginedSection = this._renderUnassginedSection.bind(this);
        this._renderAssignedSection = this._renderAssignedSection.bind(this);
        this.state = {
            activeIndex: 0,
            animationActive: false,
            // if exchange is active, default state hide channel
            showAllChanel: !props.exchangeActive,
            foldAssigned: false,
            foldUnassigned: false,
        }
        this._renderTabTitle = this._renderTabTitle.bind(this)
    }
    componentDidMount(){
        if (!this.props.exchangeNetwork.fetched){
            this.props.readUnassignedFromDB()
            this.props.readAssignedFromDB()
            this.props.readInternFromDB()
            this.props.readExchangeFromDB()
            this.props.readCustomizations()
            this.setState({animationActive: true})
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if(!this.state.animationActive){
            this.setState({animationActive: true})
        }
    }
    _renderTabTitle(title, unread, imgSrc, index){
        let fillColor = '#a5a5a5'
        if(this.state.activeIndex === index){
            fillColor = '#4ec1e0'
        }
        return (
            <Flex center onClick={()=>this.setState({activeIndex: index, animationActive: false})} h='100%' w='100%'
                borderBottom={this.state.activeIndex===index?'5px solid #4ec1e0': '5px solid transparent'}
            >
                <Flex marginRight='3px'>
                    <SVG cacheGetRequests={true} style={{fill: fillColor, height: '30px', width: '30px'}} src={imgSrc} />
                </Flex>
                <Flex color={fillColor} fontSize='20px' position='rellative'>
                {title} {unread  > 0 && <Flex center className={style.ConversationUnreadsIcon}>{unread}</Flex>}
                </Flex>
            </Flex>
        )
    }

    _renderTabs(){
        let ticketTab = this._renderTabTitle('Ärenden', this.props.numberOfUnreadTickets, '/images/Visitor_M.svg', 0)
        let coworkerTab = this._renderTabTitle('Medarbetare', this.props.numberOfUnreadIntern, '/images/Employee_M.svg', 1)
        //<ExchangeNotification/>

        const ExchangeWithPayment = WithPaymentPermission('exchange')(ExchangeNotification)

        let tab1 = (
           <Flex column grow overflowY='scroll' overflowX='hidden'>
               {this.props.exchangeActive && <ExchangeWithPayment/>}
                {this._renderAssignedSection('Pågående', this.props.assignedTickets)}
                <Flex h='8px' shrink={0}></Flex>
                {this._renderUnassginedSection('Obesvarade', this.props.unassignedTickets)}
            </Flex>
        )
        let tab2 = (
            <Flex column grow overflowY='scroll' overflowX='hidden'>
                <Flex column shrink={0} width='100%' my='5px' vAlignContent='center'>
                    <Preview room={this.props.companyRoom} type='public' shrink={0}/>
                </Flex>
                {this._renderSection('Privat', this.props.internConversations, false)}
            </Flex>
        )

        return (
            <Flex grow className={style.LeftPanelTabs}>
                <Tabs
                    active={this.state.activeIndex}
                    header={[ticketTab, coworkerTab]}
                    body={[tab1, tab2]}
                />
            </Flex>
        )
    }

    _renderSection(title, conversations, withSize=true){
        let sortedConversations = conversations.sort((convo1, convo2) => {
                let id1 = convo1.getIn(['entries', 'confirmed', -1, 'id'], 0);
                let id2 = convo2.getIn(['entries', 'confirmed', -1, 'id'], 0);
                return id2 - id1;
            }).toArray().map((conversation)=>{
                let room = conversation.getIn(['info', 'payload', 'room'])
                let type = ConversationSelector.typeOf(conversation)
                if(!room) return null;
                return  <Preview key={room+'-'+type} room={room} type={type} shrink={0}/>
            })
        return (
            <Flex column shrink={0}>
                <Flex className={style.sectionHeader} my='5px' vAlignContent='center'>
                {title} {withSize && ` (${conversations.size})`}
                </Flex>
                <Flex column hAlignContent='center' width='100%' shrink={0}>
                        {sortedConversations}
                </Flex>
            </Flex>
        );
    }
    _renderAssignedSection(title, conversations, withSize=true){
        let sortedConversations = conversations.sort((convo1, convo2) => {
                let id1 = convo1.getIn(['entries', 'confirmed', -1, 'id'], 0);
                let id2 = convo2.getIn(['entries', 'confirmed', -1, 'id'], 0);
                return id2 - id1;
            }).toArray().map((conversation)=>{
                let room = conversation.getIn(['info', 'payload', 'room'])
                let type = ConversationSelector.typeOf(conversation)
                if(!room) return null;
                return  <Preview key={room+'-'+type} room={room} type={type} shrink={0}/>
            })
        return (
            <Flex column shrink={0}>
                <Flex className={style.sectionHeader} my='5px' vAlignContent='center'>
                    <Flex ml='20px' mr='auto'>
                        Pågående {withSize && ` (${conversations.size})`}
                    </Flex>
                    <Arrow direction={!this.state.foldAssigned?'up':'down'} onClick={()=>this.setState({foldAssigned: !this.state.foldAssigned})}/>
                </Flex>
                <Flex column hAlignContent='center' width='100%' shrink={0}>
                        {!this.state.foldAssigned && sortedConversations}
                </Flex>
            </Flex>
        );
    }
    _renderUnassginedSection(title, conversations, withSize=true){
        let sortedConversations = conversations.sort((convo1, convo2) => {
                let id1 = convo1.getIn(['entries', 'confirmed', -1, 'id'], 0);
                let id2 = convo2.getIn(['entries', 'confirmed', -1, 'id'], 0);
                return id2 - id1;
            }).toArray()
        let options = ExchangeSelector.getActiveOptions(this.props.options.toJS())
        return (
            <Flex column>
                <Flex className={style.sectionHeader} vAlignContent='center' shrink={0}>
                    <Flex marginLeft='20px' mr='auto'>
                        {title} {withSize && ` (${conversations.size})`}
                    </Flex>
                    {this.props.exchangeActive &&
                    <Flex fontSize='14px' mr='4px' color='MediumGray6'  onClick={()=>{this.setState({showAllChanel: !this.state.showAllChanel})}} cursor='pointer' center>
                        Visa alla kanaler
                        <CheckboxInput height='15px' width='15px' color={this.state.showAllChanel?'#4ec1e0':'#5a5a5a'} checked={this.state.showAllChanel}/>
                    </Flex>
                    }
                    <Arrow direction={!this.state.foldUnassigned?'up':'down'} onClick={()=>this.setState({foldUnassigned: !this.state.foldUnassigned})}/>
                </Flex>
                <Flex column hAlignContent='center' width='100%'>
                        {
                            !this.state.foldUnassigned &&
                            sortedConversations.map((conversation) => {
                                let room = conversation.getIn(['info', 'payload', 'room'])
                                let type = ConversationSelector.typeOf(conversation)
                                let key = conversation.getIn(['info', 'payload', 'company_ticket_id'])
                                let exchange_id = conversation.getIn(['info', 'payload', 'exchange', 'id'], -1)
                                let o = _.find(options, (o)=>{
                                    return o.id === exchange_id
                                })
                                if(exchange_id === -1){

                                }else if(!o && !this.state.showAllChanel){
                                    return null;
                                }

                                return(
                                        <Preview key={key} room={room} type={type} shrink={0}/>
                                )
                            })
                        }
                        <Flex height='35px' w='100%' shrink={0}/>
                </Flex>
            </Flex>
        );
    }


    render(){
        return (
            <Flex basis='100%' column borderRight='1px solid lightgrey'>
                {this._renderTabs()}
            </Flex>
        )
    }
}

const {selector: unassignedTicketsSelector, dispatcher: unassignedTicketsReadFromDB} = ConversationModel.readUnassignedFromDB()
const {selector: assignedTicketsSelector, dispatcher: assignedTicketsReadFromDB} = ConversationModel.readAssignedFromDB()
const {selector: internSelector, dispatcher: internReadFromDB} = ConversationModel.readInternFromDB()
const {selector: exchangeSelector, dispatcher: exchangeReadDis} = ExchangeModel.read()
const {dispatcher: customizationDispatcher} = CustomizationModel.read()


function mapDispatchToProps(dispatch, props) {
    return {
        readExchangeFromDB: ()=>dispatch(exchangeReadDis()),
        readUnassignedFromDB: ()=>dispatch(unassignedTicketsReadFromDB()),
        readAssignedFromDB: ()=>dispatch(assignedTicketsReadFromDB()),
        readInternFromDB: ()=>dispatch(internReadFromDB()),
        readCustomizations: () => dispatch(customizationDispatcher())
    }
}


function mapStateToProps(state){
    let userId = state.getIn(['user', 'login', 'id'])

    const assignedTickets = assignedTicketsSelector(state)['assigned']
    const unassignedTickets = unassignedTicketsSelector(state)['unassigned']
    const internConversations = internSelector['intern'](state)

    const numberOfUnreadTickets = ConversationSelector.getNumberOfUnreadConversations(unassignedTickets, userId) + ConversationSelector.getNumberOfUnreadConversations(assignedTickets, userId)
    const companyRoom = CompanySelector.getCompanyRoom(state)


    const numberOfUnreadInternPublic = ConversationSelector.getUnreadFromState(state, companyRoom, userId)
    let numberOfUnreadIntern = ConversationSelector.getNumberOfUnreadConversations(internConversations, userId) + numberOfUnreadInternPublic

    return {
        unassignedTickets, assignedTickets, internConversations,
        numberOfUnreadIntern, numberOfUnreadTickets, companyRoom,
        exchangeActive: CustomizaionSelector.getExchangeActive(state),
        options: ExchangeSelector.getOptions(state),
        exchangeNetwork: exchangeSelector['network'](state)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftPanel);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/LeftPanel/index.js